import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import _ from 'lodash';
import { TAction } from '../actions/types/action';
import {
  SET_EVENT_REGISTRATION_DATA,
  SET_EVENT_REGISTRATION_FORM_STATE,
  CLEAR_EVENT_REGISTRATION_DATA,
  SHOW_LOADING_SPINNER,
  FORCE_RELOAD
} from '../actions/eventRegistrationActionCreator';

const defaultState = {
  isLoaded: false,
  isLoading: false,
  serverData: {},
  formState: {}
};

export default function eventRegistrationReducer(
  state: any = _.cloneDeep(defaultState),
  action: TAction<any>
): Partial<any> {
  switch (action.type) {
    case SHOW_LOADING_SPINNER: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case SET_EVENT_REGISTRATION_DATA: {
      return {
        ...state,
        serverData: {
          ...state.serverData,
          ...action.payload
        },
        isLoaded: true,
        isLoading: false
      };
    }
    case FORCE_RELOAD: {
      return {
        ...state,
        isLoaded: false,
        isLoading: false
      };
    }
    case SET_EVENT_REGISTRATION_FORM_STATE: {
      return {
        ...state,
        formState: {
          ...state.formState,
          ...action.payload
        }
      };
    }
    case CLEAR_EVENT_REGISTRATION_DATA: {
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        formState: _.cloneDeep(defaultState.formState),
        serverData: _.cloneDeep(defaultState.serverData)
      };
    }
    case LOCATION_CHANGE: {
      return {
        ...state,
        isLoading: false,
        isLoaded: false
      };
    }
    default:
      return state;
  }
}
